import { NavLink, useLocation } from "react-router-dom";

import { useBrand } from "../brand/BrandContext";

import { Mark } from "./Mark";

const SECTIONS: { path: string; label: string; number: string }[] = [
  { path: "/", label: "Cover", number: "00" },
  { path: "/foundation", label: "Foundation", number: "01" },
  { path: "/voice", label: "Voice & language", number: "02" },
  { path: "/logo", label: "Logo system", number: "03" },
  { path: "/typography", label: "Typography", number: "04" },
  { path: "/colour", label: "Colour", number: "05" },
  { path: "/imagery", label: "Imagery", number: "06" },
  { path: "/motifs", label: "Motifs & motion", number: "07" },
  { path: "/applications", label: "Applications", number: "08" },
  { path: "/use-cases", label: "Use cases", number: "09" },
];

export function SectionNav() {
  const location = useLocation();
  const { variant } = useBrand();

  return (
    <aside className="fixed top-0 left-0 z-30 hidden h-screen w-72 flex-col justify-between border-r p-7 md:flex border-rule">
      <div>
        <NavLink to="/" className="block">
          <div className="flex items-center gap-2.5">
            <Mark size={28} />
            <span className="font-body text-[11px] font-semibold tracking-[0.30em] uppercase text-ink">
              Vihangam Yog
            </span>
          </div>
          <p className="mt-1 ml-[42px] font-display text-[13px] italic text-ink-soft">
            Brand book
          </p>
        </NavLink>

        <nav className="mt-10 space-y-1">
          {SECTIONS.map((s) => {
            const active = location.pathname === s.path;
            return (
              <NavLink
                key={s.path}
                to={s.path}
                className={`group flex items-baseline gap-3 py-1.5 font-body text-[13px] transition-colors ${
                  active ? "text-ink" : "text-ink-soft hover:text-ink"
                }`}
              >
                <span
                  className={`font-display text-[11px] tabular-nums tracking-[0.2em] ${
                    active ? "text-amber" : "text-ink-soft"
                  }`}
                >
                  {s.number}
                </span>
                <span
                  className={`${active ? "font-medium" : ""} transition-colors`}
                >
                  {s.label}
                </span>
                {active && (
                  <span
                    className="ml-auto h-px w-6 self-center"
                    style={{ background: "var(--amber)" }}
                  />
                )}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <div className="border-t pt-5 border-rule">
        <p className="font-body text-[10px] tracking-[0.36em] uppercase text-ink-soft">
          Variant
        </p>
        <p className="mt-1 font-display text-[20px] italic text-amber">
          {variant.name}
        </p>
        <p className="mt-1 font-body text-[12px] text-ink-soft">
          {variant.oneLiner}
        </p>
      </div>
    </aside>
  );
}
